import { gql } from '@apollo/client';

const TaxjarCategorySyncRunInfo = gql`
  fragment TaxjarCategorySyncRunInfo on TaxjarCategorySyncRun {
    id
    completedAt
    correlationId
    createdCount
    deactivatedCount
    errorCode
    errorHttpStatus
    errorRetryable
    initiatedById
    receivedCount
    requestedAt
    startedAt
    state
    updatedCount
  }
`;

export default TaxjarCategorySyncRunInfo;
